import { useEffect } from 'react';

interface SeoOptions {
  title: string;
  description: string;
  canonicalPath?: string;
}

export default function useSeo({ title, description, canonicalPath = '/' }: SeoOptions) {
  useEffect(() => {
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', description);
    else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = description;
      document.head.appendChild(meta);
    }

    const base = 'https://mangareport.github.io';
    const canonical = document.querySelector('link[rel="canonical"]');
    const canonicalHref = `${base}${canonicalPath === '/' ? '/' : canonicalPath}`;
    if (canonical) canonical.setAttribute('href', canonicalHref);
    else {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonicalHref;
      document.head.appendChild(link);
    }
  }, [title, description, canonicalPath]);
}